import clsx from "clsx"
import { ReactElement, cloneElement, forwardRef, isValidElement } from "react"

import styles from "./ExtraTouchArea.module.scss"
import { ExtraTouchAreaProps } from "./ExtraTouchArea.types"

function ExtraTouchArea(props: ExtraTouchAreaProps, ref: React.Ref<HTMLElement>) {
    const { children, extraTouchArea = 8, sides = "all" } = props

    if (!isValidElement(children)) {
        return null
    }

    return cloneElement(children as ReactElement, {
        ref,
        className: clsx(
            (children as ReactElement<React.HTMLAttributes<HTMLElement>>).props?.className,
            styles.extraTouchArea,
            styles[`${sides}Sides`],
        ),
        style: {
            "--extra-touch-area": `${extraTouchArea}px`,
            ...((children as ReactElement<React.HTMLAttributes<HTMLElement>>).props?.style || {}),
        },
    })
}

export default forwardRef(ExtraTouchArea)
